<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <a routerLink="/operational-dashboard/trending-titles">Trending Titles</a>
    <mat-radio-group (change)="selectedTimeChanged($event)" [(ngModel)]="selectedTimeRangeRadioButton">
      @for (filter of trendingTitlesFilters; track filter) {
        <mat-radio-button [value]="filter">{{filter.filterName}}</mat-radio-button>
      }
    </mat-radio-group>
  </div>
</div>

@if (isLoading) {
  <insight-loading-spinner
    loadingMessage="Loading...">
  </insight-loading-spinner>
}

@if (!isLoading && !didError) {
  <mat-table [dataSource]="tableDataSource">
    <!-- Title Column -->
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a routerLink="/order-shipment" [queryParams]="{search: element.title.trim()}">
          {{element.title}}
        </a>
      </mat-cell>
    </ng-container>
    <!-- Media Type Column -->
    <ng-container matColumnDef="mediaType">
      <mat-header-cell *matHeaderCellDef> Media Type </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.mediaType}} </mat-cell>
    </ng-container>
    <!-- Order Count Column -->
    <ng-container matColumnDef="orderCount">
      <mat-header-cell *matHeaderCellDef> Order Count </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.orderCount}} </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
}

@if (!isLoading && didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting orders by shipment.
    </div>
  </div>
}
